import { useQuery } from '@tanstack/react-query'

import { useApiAxios } from '@lib/rest-web'
import { DataPackages } from '@piv/lib/api-types'

export type { DataPackages as Types }

export const useWakeupCall = () => {
  const api = useApiAxios()

  return useQuery({
    queryKey: ['healthcheck'],
    queryFn: async ({ signal }) => {
      const result = await api.get<void>('healthcheck', {
        validateStatus: (status) => status === 200,
        signal,
      })

      return result.data
    },
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    gcTime: 60000,
    staleTime: 60000,
  })
}
